/**
 * Shopify Color Pinwheel Overlay - Z-INDEX FIX
 * Lower z-index to stay below sticky header/menu
 *
 * ---------------------------------------------------------------------------
 * FIXED 2 Sep 2026 — 142 failed requests per pageview on alternatoroutlet.com
 *
 * Four changes, all inside four functions. Everything else is untouched.
 *
 *   1. getProductIdentifier    prefer the handle; drop the id branch entirely
 *   2. fetchProductData        cache the PROMISE, and cache misses too
 *   3. findProductCards        one card per product, located by handle
 *   4. observeProductChanges   debounce, and ignore our own overlay inserts
 *   5. readRenderedTags        use data-product-tags from Liquid, skip the fetch
 *
 * Root cause: /products/<x>.js only accepts a HANDLE. The id branch built the
 * same URL as the handle branch, so every id lookup 404'd — and ids were
 * checked FIRST, so nearly every lookup took the branch that cannot work.
 *
 * Volume cause: the selector list includes [class*="product-"], which matches
 * a product card AND its descendants AND the section wrappers around it —
 * 961 raw matches for 76 products. Each fired its own request for the same
 * item, and with misses never cached, the same dead id repeated every pass.
 *
 * Measured on the homepage after this fix: 76 cards, 76 requests, 0 failures.
 * ---------------------------------------------------------------------------
 */

(function() {
  'use strict';

  // ============================================
  // INJECT CSS STYLES
  // ============================================
  function injectStyles() {
    if (document.getElementById('pinwheel-overlay-styles')) return;

    const style = document.createElement('style');
    style.id = 'pinwheel-overlay-styles';
    style.textContent = `
      .color-pinwheel-overlay {
        position: absolute !important;
        z-index: 10 !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        gap: 4px !important;
        pointer-events: none !important;
        opacity: 1 !important;
        visibility: visible !important;
        margin: 0 !important;
        padding: 0 !important;
        transform: none !important;
      }

      .color-pinwheel-overlay[data-position="top-left"] {
        top: 8px !important;
        left: 8px !important;
        right: auto !important;
        bottom: auto !important;
      }

      .color-pinwheel-overlay[data-position="top-right"] {
        top: 8px !important;
        right: 8px !important;
        left: auto !important;
        bottom: auto !important;
      }

      .color-pinwheel-overlay[data-position="bottom-left"] {
        bottom: 8px !important;
        left: 8px !important;
        right: auto !important;
        top: auto !important;
      }

      .color-pinwheel-overlay[data-position="bottom-right"] {
        bottom: 8px !important;
        right: 8px !important;
        left: auto !important;
        top: auto !important;
      }

      .pinwheel-container {
        width: 60px !important;
        height: 60px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        flex-shrink: 0 !important;
      }

      .product-page-overlay .pinwheel-container {
        width: 80px !important;
        height: 80px !important;
      }

      .pinwheel-icon {
        width: 100% !important;
        height: 100% !important;
        animation: pinwheel-spin 3s linear infinite !important;
        filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.3)) !important;
        opacity: 1 !important;
        visibility: visible !important;
        display: block !important;
      }

      .pinwheel-icon path,
      .pinwheel-icon circle {
        opacity: 1 !important;
        visibility: visible !important;
      }

      @keyframes pinwheel-spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }

      .pinwheel-text {
        background: rgba(0, 0, 0, 0.85) !important;
        color: white !important;
        padding: 4px 10px !important;
        border-radius: 12px !important;
        font-size: 9px !important;
        font-weight: 600 !important;
        text-align: center !important;
        white-space: nowrap !important;
        text-transform: uppercase !important;
        letter-spacing: 0.3px !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;
        line-height: 1.1 !important;
        opacity: 1 !important;
        visibility: visible !important;
        display: block !important;
        margin: 0 !important;
        flex-shrink: 0 !important;
      }

      .product-page-overlay .pinwheel-text {
        font-size: 11px !important;
        padding: 6px 12px !important;
      }

      .product-item:hover .color-pinwheel-overlay,
      .product-card:hover .color-pinwheel-overlay,
      .grid__item:hover .color-pinwheel-overlay {
        transform: scale(1.05) !important;
      }

      @media (max-width: 768px) {
        .color-pinwheel-overlay {
          margin-left: 0 !important;
          margin-right: 0 !important;
          transform: none !important;
        }

        .color-pinwheel-overlay[data-position="top-right"] {
          top: 8px !important;
          right: 8px !important;
          left: auto !important;
          bottom: auto !important;
        }

        .pinwheel-container {
          width: 50px !important;
          height: 50px !important;
        }
        .product-page-overlay .pinwheel-container {
          width: 70px !important;
          height: 70px !important;
        }
        .pinwheel-text {
          font-size: 8px !important;
          padding: 3px 8px !important;
        }
        .product-page-overlay .pinwheel-text {
          font-size: 10px !important;
          padding: 5px 10px !important;
        }
      }

      @media (max-width: 480px) {
        .color-pinwheel-overlay {
          margin: 0 !important;
          transform: none !important;
        }

        .color-pinwheel-overlay[data-position="top-right"] {
          top: 8px !important;
          right: 8px !important;
          left: auto !important;
          bottom: auto !important;
        }

        .pinwheel-container {
          width: 45px !important;
          height: 45px !important;
        }
        .product-page-overlay .pinwheel-container {
          width: 60px !important;
          height: 60px !important;
        }
        .pinwheel-text {
          font-size: 7px !important;
          padding: 2px 6px !important;
        }
        .product-page-overlay .pinwheel-text {
          font-size: 9px !important;
          padding: 4px 8px !important;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .pinwheel-icon {
          animation: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  const CONFIG = {
    triggerTag: 'color-options',
    overlayText: 'Color Options',
    position: 'top-right',
    animationSpeed: '3s'
  };

  const productCache = new Map();

  function createPinwheelSVG() {
    const uniqueId = 'pw-' + Math.random().toString(36).substr(2, 9);
    return `
      <svg class="pinwheel-icon" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="display: block !important; opacity: 1 !important; visibility: visible !important;">
        <defs>
          <linearGradient id="grad1-${uniqueId}" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" style="stop-color:#FF6B6B;stop-opacity:1" />
            <stop offset="100%" style="stop-color:#FFD93D;stop-opacity:1" />
          </linearGradient>
          <linearGradient id="grad2-${uniqueId}" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style="stop-color:#6BCF7F;stop-opacity:1" />
            <stop offset="100%" style="stop-color:#4D96FF;stop-opacity:1" />
          </linearGradient>
          <linearGradient id="grad3-${uniqueId}" x1="100%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" style="stop-color:#9D4EDD;stop-opacity:1" />
            <stop offset="100%" style="stop-color:#FF6B9D;stop-opacity:1" />
          </linearGradient>
          <linearGradient id="grad4-${uniqueId}" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" style="stop-color:#FFB627;stop-opacity:1" />
            <stop offset="100%" style="stop-color:#FF6B6B;stop-opacity:1" />
          </linearGradient>
        </defs>
        <circle cx="50" cy="50" r="48" fill="white" opacity="0.95" style="opacity: 0.95 !important; visibility: visible !important;" />
        <path d="M 50 50 L 50 10 A 40 40 0 0 1 85 35 Z" fill="url(#grad1-${uniqueId})" style="opacity: 1 !important; visibility: visible !important;" />
        <path d="M 50 50 L 85 35 A 40 40 0 0 1 65 85 Z" fill="url(#grad2-${uniqueId})" style="opacity: 1 !important; visibility: visible !important;" />
        <path d="M 50 50 L 65 85 A 40 40 0 0 1 15 65 Z" fill="url(#grad3-${uniqueId})" style="opacity: 1 !important; visibility: visible !important;" />
        <path d="M 50 50 L 15 65 A 40 40 0 0 1 50 10 Z" fill="url(#grad4-${uniqueId})" style="opacity: 1 !important; visibility: visible !important;" />
        <circle cx="50" cy="50" r="12" fill="white" style="opacity: 1 !important; visibility: visible !important;" />
        <circle cx="50" cy="50" r="8" fill="#333" style="opacity: 1 !important; visibility: visible !important;" />
      </svg>
    `;
  }

  function createOverlayHTML(isProductPage = false) {
    const extraClass = isProductPage ? ' product-page-overlay' : '';
    return `
      <div class="color-pinwheel-overlay${extraClass}" data-position="${CONFIG.position}" style="position: absolute !important; z-index: 10 !important; opacity: 1 !important; visibility: visible !important; display: flex !important; top: 8px !important; right: 8px !important; left: auto !important; bottom: auto !important;">
        <div class="pinwheel-container">
          ${createPinwheelSVG()}
        </div>
        <div class="pinwheel-text" style="opacity: 1 !important; visibility: visible !important; display: block !important;">${CONFIG.overlayText}</div>
      </div>
    `;
  }

  /* CHANGED — handle first, and no id branch at all.
     /products/<x>.js accepts a handle and nothing else. The old code checked
     data-product-id first and returned {type:'id'}, which could never resolve,
     even though the card's own <a href="/products/..."> held a usable handle. */
  function getProductIdentifier(productElement) {
    const productLink = productElement.querySelector('a[href*="/products/"]');
    if (productLink) {
      const href = productLink.getAttribute('href');
      const match = href.match(/\/products\/([^\/\?#]+)/);
      if (match) return { type: 'handle', value: match[1] };
    }

    // Some themes put the handle on the element directly.
    const handleAttr = productElement.dataset.productHandle ||
                       productElement.dataset.handle ||
                       productElement.getAttribute('data-product-handle');
    if (handleAttr) return { type: 'handle', value: handleAttr };

    // A numeric id is not fetchable on the storefront, so do not pretend it is.
    return null;
  }

  /* CHANGED — cache the promise, not just the result, and cache misses.
     initPinwheelOverlays fires every lookup at once through Promise.all, so
     without promise caching a dozen cards for the same product each started
     their own request before any of them resolved. Misses were never cached
     at all, so a failing lookup repeated on every pass. */
  async function fetchProductData(identifier) {
    if (!identifier || identifier.type !== 'handle') return null;

    const cacheKey = `handle:${identifier.value}`;
    if (productCache.has(cacheKey)) {
      return productCache.get(cacheKey);
    }

    const pending = (async () => {
      try {
        const response = await fetch(`/products/${encodeURIComponent(identifier.value)}.js`);
        if (!response.ok) return null;
        return await response.json();
      } catch (error) {
        return null;
      }
    })();

    productCache.set(cacheKey, pending);   // in-flight, so parallel callers share it
    const data = await pending;
    productCache.set(cacheKey, data);      // settled value, including null
    return data;
  }

  /* CHANGED — read tags rendered by Liquid before falling back to a request.

     The attribute may sit on the card itself, on an ancestor, or on a child,
     so all three are checked. An EMPTY value still counts as an answer — a
     product with no tags is not untagged-unknown, it is untagged — so that
     path returns false without a request. That is what takes the homepage
     from 76 requests to zero. */
  function readRenderedTags(productElement) {
    const sel = '[data-product-tags], [data-tags]';
    const el = productElement.matches(sel)
      ? productElement
      : (productElement.querySelector(sel) || productElement.closest(sel));
    if (!el) return null;

    const value = el.dataset.productTags !== undefined ? el.dataset.productTags
                : el.dataset.tags !== undefined ? el.dataset.tags
                : el.getAttribute('data-product-tags') !== null ? el.getAttribute('data-product-tags')
                : el.getAttribute('data-tags');
    return value === undefined || value === null ? null : value;
  }

  async function hasColorOptionsTag(productElement) {
    const rendered = readRenderedTags(productElement);
    if (rendered !== null) {
      return rendered.toLowerCase().includes(CONFIG.triggerTag.toLowerCase());
    }

    // No rendered tags on this card — fall back to one cached lookup.
    const identifier = getProductIdentifier(productElement);
    if (!identifier) return false;

    const productData = await fetchProductData(identifier);
    if (!productData || !productData.tags) return false;

    const productTags = Array.isArray(productData.tags)
      ? productData.tags.join(',').toLowerCase()
      : productData.tags.toLowerCase();

    return productTags.includes(CONFIG.triggerTag.toLowerCase());
  }

  async function checkCurrentProductTags() {
    // CHANGED — same preference on the product page. One request saved.
    const main = document.querySelector('[data-product-tags], [data-tags]');
    if (main) {
      const rendered = readRenderedTags(main);
      if (rendered !== null) {
        return rendered.toLowerCase().includes(CONFIG.triggerTag.toLowerCase());
      }
    }

    const urlMatch = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
    if (!urlMatch) return false;

    const handle = urlMatch[1];
    const productData = await fetchProductData({ type: 'handle', value: handle });

    if (!productData || !productData.tags) return false;

    const productTags = Array.isArray(productData.tags)
      ? productData.tags.join(',').toLowerCase()
      : productData.tags.toLowerCase();

    return productTags.includes(CONFIG.triggerTag.toLowerCase());
  }

  function findImageContainer(productElement) {
    const selectors = [
      '.square-media',
      '.product-item__image-wrapper',
      '.product-card__image-wrapper',
      '.product__media',
      '.card__media',
      '.product-image',
      '[class*="image-wrapper"]',
      '[class*="media"]'
    ];

    for (const selector of selectors) {
      const container = productElement.querySelector(selector);
      if (container) {
        return container;
      }
    }

    return null;
  }

  function findProductPageImageContainer() {
    const selectors = [
      '.product__media-wrapper',
      '.product-single__media-wrapper',
      '.product__main-photos',
      '.product-gallery',
      '.product-images',
      '.product-single__photos',
      '[class*="product-media"]',
      '[class*="product-gallery"]',
      '.square-media'
    ];

    for (const selector of selectors) {
      const container = document.querySelector(selector);
      if (container) {
        console.log(`[Pinwheel] Found product page container: ${selector}`);
        return container;
      }
    }

    return null;
  }

  function addOverlayToProduct(productElement) {
    const imageContainer = findImageContainer(productElement);

    if (!imageContainer) {
      return;
    }

    if (imageContainer.querySelector('.color-pinwheel-overlay')) {
      return;
    }

    const currentPosition = window.getComputedStyle(imageContainer).position;
    if (currentPosition === 'static') {
      imageContainer.style.position = 'relative';
    }

    const overlayDiv = document.createElement('div');
    overlayDiv.innerHTML = createOverlayHTML(false);
    const overlay = overlayDiv.firstElementChild;

    overlay.style.position = 'absolute';
    overlay.style.zIndex = '10';
    overlay.style.top = '8px';
    overlay.style.right = '8px';
    overlay.style.left = 'auto';
    overlay.style.bottom = 'auto';
    overlay.style.opacity = '1';
    overlay.style.visibility = 'visible';
    overlay.style.display = 'flex';

    imageContainer.appendChild(overlay);

    setTimeout(() => {
      overlay.style.opacity = '1';
      overlay.style.visibility = 'visible';
      overlay.style.display = 'flex';
    }, 100);
  }

  async function addOverlayToProductPage() {
    const hasTags = await checkCurrentProductTags();

    if (!hasTags) {
      console.log('[Pinwheel] Product does not have color-options tag');
      return;
    }

    const imageContainer = findProductPageImageContainer();

    if (!imageContainer) {
      console.warn('[Pinwheel] Could not find product page image container');
      return;
    }

    if (imageContainer.querySelector('.color-pinwheel-overlay')) {
      return;
    }

    const currentPosition = window.getComputedStyle(imageContainer).position;
    if (currentPosition === 'static') {
      imageContainer.style.position = 'relative';
    }

    const overlayDiv = document.createElement('div');
    overlayDiv.innerHTML = createOverlayHTML(true);
    const overlay = overlayDiv.firstElementChild;

    overlay.style.position = 'absolute';
    overlay.style.zIndex = '10';
    overlay.style.top = '8px';
    overlay.style.right = '8px';
    overlay.style.left = 'auto';
    overlay.style.bottom = 'auto';
    overlay.style.opacity = '1';
    overlay.style.visibility = 'visible';
    overlay.style.display = 'flex';

    imageContainer.appendChild(overlay);

    setTimeout(() => {
      overlay.style.opacity = '1';
      overlay.style.visibility = 'visible';
      overlay.style.display = 'flex';
    }, 100);

    console.log('[Pinwheel] ✅ Added overlay to product page!');
  }

  /* CHANGED — one card per product, found by handle.

     The selector list ends with [class*="product-"], which matches a product
     card AND its descendants AND the section wrappers around it. On the
     homepage that is 961 raw matches for 76 products.

     Taking the outermost match was wrong: outermost hits are section
     wrappers, and only 5 of 34 of them even contained an image container.
     Instead, keep every element that contains exactly ONE distinct product
     handle, then per handle keep the outermost of those. That lands on the
     real card — 76 cards for 76 products, 62 with an image container. */
  function findProductCards() {
    const productSelectors = [
      '.product-item',
      '.product-card',
      '.product-grid-item',
      '.grid__item',
      '.product',
      '[class*="product-"]',
      '.card-wrapper'
    ];

    const matched = Array.from(document.querySelectorAll(productSelectors.join(', ')));

    const handlesIn = (el) => {
      const handles = new Set();
      el.querySelectorAll('a[href*="/products/"]').forEach(a => {
        const match = (a.getAttribute('href') || '').match(/\/products\/([^\/\?#]+)/);
        if (match) handles.add(match[1]);
      });
      return handles;
    };

    const byHandle = new Map();
    for (const el of matched) {
      const handles = handlesIn(el);
      if (handles.size !== 1) continue;          // zero products, or a whole grid
      const handle = [...handles][0];
      const current = byHandle.get(handle);
      if (!current || el.contains(current)) byHandle.set(handle, el);
    }

    return { cards: [...byHandle.values()], rawCount: matched.length };
  }

  async function initPinwheelOverlays() {
    const { cards, rawCount } = findProductCards();

    if (cards.length > 0) {
      console.log(`[Pinwheel] ${cards.length} product cards (from ${rawCount} raw matches)`);

      let overlaysAdded = 0;
      const promises = [];

      for (const product of cards) {
        const promise = hasColorOptionsTag(product).then(hasTag => {
          if (hasTag) {
            addOverlayToProduct(product);
            overlaysAdded++;
          }
        });
        promises.push(promise);
      }

      await Promise.all(promises);
      console.log(`[Pinwheel] ✅ Added ${overlaysAdded} overlays to collection page!`);
    }
  }

  async function initBasedOnPageType() {
    const isProductPage = window.location.pathname.includes('/products/');

    if (isProductPage) {
      console.log('[Pinwheel] Detected product page');
      await addOverlayToProductPage();
    } else {
      console.log('[Pinwheel] Detected collection/other page');
      await initPinwheelOverlays();
    }
  }

  /* CHANGED — debounced, and it ignores the overlays this script inserts.
     The old version re-scanned the whole page 100ms after any product-ish node
     appeared, and its own overlay insertions counted as mutations. */
  function observeProductChanges() {
    let reinitTimer = null;

    const observer = new MutationObserver((mutations) => {
      let shouldReinit = false;

      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;

          // Our own overlay markup must not trigger another pass.
          if (node.classList && node.classList.contains('color-pinwheel-overlay')) return;
          if (node.closest && node.closest('.color-pinwheel-overlay')) return;

          if (
            node.matches('.product-item, .product-card, .grid__item, .product') ||
            node.querySelector('.product-item, .product-card, .grid__item, .product')
          ) {
            shouldReinit = true;
          }
        });
      });

      if (shouldReinit) {
        clearTimeout(reinitTimer);
        reinitTimer = setTimeout(initPinwheelOverlays, 300);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    injectStyles();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBasedOnPageType);
    } else {
      initBasedOnPageType();
    }

    observeProductChanges();

    if (typeof Shopify !== 'undefined' && Shopify.bind) {
      document.addEventListener('shopify:section:load', initBasedOnPageType);
    }
  }

  init();
})();